import React, { useState } from "react";
import { getConfiguration } from '../../data/utils/configuration';
import { xs_languageCode } from "../..";
import ClapprPlayer from "../video-player/ClapprPlayer";

import './LiveTv.css';


export default function LiveTv(props) {
    const conf = getConfiguration();
    const [showedChannel, setShowedChannel] = useState(0);
    const videoChannelList = conf?.phvn?.length > 0 ? conf?.phvn.filter((p)=> {return p.cntnrm == props.container})  : [];
    const videoChannel = videoChannelList?.[showedChannel];

    function VideoChannelButton(props){
    	const obj = props.obj;
    	const index = props.index;
		const title = obj.loc?.[xs_languageCode] || (index + 1);
		return <div className={"live-tv-button-channel " + (obj.pty) + (index === showedChannel? ' selected':'')} onClick={() => {setShowedChannel(index)}}>
		{
			obj.ico?
			<img src={obj.ico} />
			:
			<>{title}</>
		}
		</div>    	
    }

    return (
        <>
        {videoChannelList?.length > 1 && 
            <div className="live-tv-header">
                <div className="live-tv-buttons-channel-container">
                    {
                        videoChannelList.map((obj, index) => {
                        return <VideoChannelButton obj={obj} index={index}  key={'button-streaming-' + index} />
                        })
                    }
                </div> 
            </div>
        }
        {videoChannel && 
        <div id="live-tv-player-container" >
             {videoChannel.pty === 'silive' && 
             <ClapprPlayer key={videoChannel.pty} playerUrl={videoChannel.pju} streamSource={videoChannel.pssu} />   
             }
         </div>

        }
           
        </>
    )
}